import { memo, useState } from "react";
import { IServiceType } from "../IServiceType";
import { useTranslation } from "react-i18next";
import { BusInternalToken } from "./BusInternalToken";
import { useFormContext } from "@4uhub/lib4uhub";
import { TIServiceForm } from "../../iServiceSchema";
import { IIServiceType } from "../../../../../../../models/i-service-type";
import { useIServiceType } from "../useIServiceType";
import { useParams } from "react-router-dom";
import { IBusInternalTokenExternal } from "../models";

interface IBusInternalTokenWrapperProps {
  iServiceTypes: IIServiceType[];
}

const U_BUS_IMAGE = { src: "/4uhubApps/4uBus.png", alt: "4uBus" };

const FIELD_NAME = "busInternalToken";

const translationPath = "page.4uBus.register.iService.";

export const BusInternalTokenWrapper = memo(
  ({ iServiceTypes }: IBusInternalTokenWrapperProps) => {
    const { id } = useParams();

    const { t } = useTranslation();

    const { setValue, getValues } = useFormContext<TIServiceForm>();

    const { busInternalTokenGet, jsonParser, uBusValues } = useIServiceType();

    const [isSelected, setIsSelected] = useState(() => {
      const busInternalToken = getValues("busInternalToken");
      return !!busInternalToken;
    });

    const saveConfigsJson = (v: TIServiceForm) => {
      const values = v[FIELD_NAME];
      if (!values) return;

      return {
        token: values.token,
        host: values.host,
      };
    };

    const handleConfirm = () => {
      const uBusUserExternal = getValues("busInternalToken.uBusUserExternal");
      const busInternalToken = getValues("busInternalToken.busInternalToken");
      const iServiceType = iServiceTypes.find(
        (iServiceType) => iServiceType.code === uBusValues.code,
      );
      if (iServiceType) {
        setValue("iServiceType", iServiceType);
      }
      if (uBusUserExternal) {
        setValue("uBusUser", null);
      }
      setValue("uBusUserExternal", uBusUserExternal);
      setValue("uBusUser", busInternalToken);
      setIsSelected(true);
    };

    const handleClearConfigs = () => {
      setValue("uBusUser", null);
      setValue("iServiceType", null);
      setIsSelected(false);
    };

    const handleOpen = () => {
      setValue(FIELD_NAME, uBusValues.defaultValues);
    };

    const handleCloseSelected = () => {
      const uBusUserExternal = getValues("uBusUserExternal");
      const uBusUser = getValues("uBusUser");
      const busInternalToken = uBusUser && { busInternalToken: uBusUser };
      const configs = getValues("configs");
      const externalUBusValue = jsonParser<IBusInternalTokenExternal>(configs);
      const busInternalTokenValue = busInternalTokenGet(
        uBusUserExternal ? externalUBusValue : busInternalToken,
        uBusUserExternal,
      );
      setValue(FIELD_NAME, busInternalTokenValue);
    };

    const isEditingScreen = !!id;

    return (
      <IServiceType
        img={U_BUS_IMAGE}
        renderComponent={({ namePrefix }) => (
          <BusInternalToken namePrefix={namePrefix} />
        )}
        isSelected={isSelected}
        isEditingScreen={isEditingScreen}
        getFormattedData={saveConfigsJson}
        onConfirm={handleConfirm}
        onClearConfigs={handleClearConfigs}
        onOpen={handleOpen}
        onCloseSelected={handleCloseSelected}
        iServiceTypeName={FIELD_NAME}
        serviceName={t(translationPath + "bus_internal_token")}
      />
    );
  },
);
